import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ChevronLeft, House } from 'lucide-react'
import { cn } from '@/lib/utils'

export type BreadcrumbItem = {
    label: string
    href?: string
}

interface BreadcrumbProps {
    items: BreadcrumbItem[]
    className?: string
}

export const Breadcrumb: FC<BreadcrumbProps> = ({ items, className }): ReactNode => {
    return (
        <nav aria-label='مسیر صفحه' className={cn('min-w-0', className)}>
            <ol className='flex flex-wrap items-center gap-x-1.5 gap-y-1 text-small text-muted-foreground'>
                <li className='flex items-center'>
                    <Link
                        href='/'
                        className='flex items-center gap-1 rounded-sm transition-colors hover:text-primary-strong focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40'
                    >
                        <House className='size-3.5' aria-hidden='true' />
                        <span>صفحه اصلی</span>
                    </Link>
                </li>

                {items.map((item, index) => {
                    const isLast = index === items.length - 1

                    return (
                        <li key={`${item.label}-${index}`} className='flex min-w-0 items-center gap-1.5'>
                            <ChevronLeft className='size-3.5 shrink-0 text-subtle' aria-hidden='true' />

                            {item.href && !isLast ? (
                                <Link
                                    href={item.href}
                                    className='truncate rounded-sm transition-colors hover:text-primary-strong focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40'
                                >
                                    {item.label}
                                </Link>
                            ) : (
                                <span className={cn('truncate', isLast && 'font-medium text-foreground')} aria-current={isLast ? 'page' : undefined}>
                                    {item.label}
                                </span>
                            )}
                        </li>
                    )
                })}
            </ol>
        </nav>
    )
}
